module.exports = __webpack_public_path__ + "static/media/zarin.532fcf8a.webp";